import { render, staticRenderFns } from "./FullScreenBankSelect.vue?vue&type=template&id=81254dcc&"
import script from "./FullScreenBankSelect.vue?vue&type=script&lang=js&"
export * from "./FullScreenBankSelect.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenBankSelect.vue?vue&type=style&index=0&id=81254dcc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports